export default __webpack_public_path__ + "static/media/94t.3e8916f9.jpg";